export const policyTypeOptions = [
  { label: 'Policy Type', value: '' },
  { label: 'Ariksa', value: 'system' },
  { label: 'Custom', value: 'custom' },
];
